import axios from 'axios'
import router from '../router'
import store from '../store'
import { Notification } from 'element-ui'

var domain = document.domain.split('.')
// axios 配置
axios.defaults.timeout = 30000
axios.defaults.host = `http://${domain[0].substr(0, domain[0].length - 1)}.${domain.splice(1).join('.')}`
// axios.defaults.host = `http://${domain[0].substr(0, domain[0].length - 1)}.${domain.splice(1).join('.')}`
// axios.defaults.host = 'http://localhost'
// axios.defaults.host = 'http://192.168.0.143'
// axios.defaults.host = 'http://ywt.mooshine.cn/'
// axios.defaults.host = 'http://m.mooshine.cn/'
// axios.defaults.host = 'http://localhost:8001'
axios.defaults.baseURL = axios.defaults.host + '/Api'

// http request 拦截器
axios.interceptors.request.use(
  config => {
    store.dispatch('toggleLoading')
    store.dispatch('account/getAccessToken')
    if (store.state.account.access_token) {
      config.headers['access-token'] = `${store.state.account.access_token}`
    }
    config.timeout = 20000
    return config
  },
  error => {
    // debugger
    console.table(error)
    return Promise.reject(error)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    store.dispatch('toggleLoading')
    return response
  },
  error => {
    store.dispatch('toggleLoading')
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // console.log(router.currentRoute)
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.path }
          })
          break
        case 400:
          Notification({
            title: '失败',
            message: error.response.data.message,
            type: 'error'
          })
          break
        case 500:
          Notification({
            title: '出错',
            message: '服务器出错',
            type: 'error'
          })
          break
      }
      return Promise.reject(error.response)
    }
    Notification({
      title: '出错',
      message: error,
      type: 'error'
    })
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/http/index.js